import React from 'react'

const IndexPage = () => {
  return (
    <div>IndexPage</div>
  )
}

export default IndexPage